<template>
  <button class="btn btn-default" @click="exportCSV()">
    Exportar CSV&nbsp;
    <font-awesome-icon :icon="'file-csv'" />
  </button>
</template>

<script>
import { exportCSVFile, formatTo2DigitsDate } from '../../utils'

export default {
  props: {
    dados: {
      type: Array,
      required: true
    },
    tipo: {
      validator(value) {
        return ['agendados', 'espera'].includes(value)
      },
      required: true
    }
  },
  methods: {
    exportCSV() {
      switch (this.tipo) {
        case 'agendados':
          return this.exportAgendadosToCSV(this.dados)
        case 'espera':
          return this.exportEsperaToCSV(this.dados)
        default:
          return console.log('opção inválida')
      }
    },
    exportEsperaToCSV(data) {
      const headers = {
        posicao: 'Posição',
        cns: 'Nº Cartão SUS',
        gravidade: 'Gravidade',
        dtsolicitacao: 'Data Solicitação',
        especialidade: 'Especialidade',
        media_espera: 'Média de Espera (Dias)'
      }

      const items = [
        ...data.map(item => {
          return {
            posicao: item.posicao,
            cns: item.cns,
            gravidade: item.gravidade,
            dtsolicitacao: formatTo2DigitsDate(new Date(item.dtsolicitacao)),
            especialidade: item.especialidade,
            media_espera: item.media_espera
          }
        })
      ]

      exportCSVFile(headers, items, 'lista_espera')
    },
    exportAgendadosToCSV(data) {
      const [first] = data
      const headers = {
        cns: 'Nº Cartão SUS',
        gravidade: 'Gravidade',
        dtsolicitacao: 'Data Solicitação',
        dtagendamento: 'Data Agendamento',
        espec_exame: first.especialidade ? 'Especialidade' : 'Exame',
        unidade_destino: 'Unidade',
        endereco: 'Endereço'
      }

      const items = [
        ...data.map(item => {
          return {
            cns: item.cns,
            gravidade: item.gravidade,
            dtsolicitacao: formatTo2DigitsDate(new Date(item.dtsolicitacao)),
            dtagendamento: formatTo2DigitsDate(new Date(item.dtagendamento)),
            espec_exame: item.especialidade || item.exame,
            unidade_destino: item.unidade_destino,
            endereco: item.endereco
          }
        })
      ]

      exportCSVFile(headers, items, 'lista_agendados')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/ExportCSV.vue